import React, { useEffect, useState } from 'react'
import { Modal, FormGroup } from 'react-bootstrap'
import axios from 'axios'
import Field from '../../../../utils/Form/Widgets/Field'
import Textarea from '../../../../utils/Form/Widgets/Textarea'
import { Mail } from './core/_models'

type SendDataModalProps = {
  show: boolean
  dataRequestId: string
  onHide: () => void
  refreshFunction?: Function
  mail: Mail
}

const ReplyMailModal: React.FC<SendDataModalProps> = ({
  show,
  dataRequestId,
  onHide,
  refreshFunction,
  mail,
}) => {
  const [formData, setFormData] = useState({
    mailId: mail.mailId,
    message: '',
  })
  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      message: 'Enter mail body.',
    }))
  }, [show])

  const handleMailBodyInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target
    setFormData((prevData) => ({
      ...prevData,
      message: value,
    }))
  }

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    try {
      const response = await axios.post('/microsoft_integration/replyMail', {
        mailId: mail.mailId,
        message: formData.message,
      })

      if (response.status === 200) {
        console.log('Email sent successfully.')
        onHide()
      } else {
        console.log('API error:', response)
      }
    } catch (error) {
      console.log('An error occurred:', error)
    }
  }

  return (
    <Modal
      id='kt_modal_create_company'
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered'
      size='lg'
      show={show}
      backdrop={true}
      onHide={onHide}
    >
      <form
        onSubmit={(event) => {
          handleSubmit(event).then((response) => {
            if (refreshFunction) {
              refreshFunction(response)
            }
          })
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Reply Mail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormGroup>
            <FormGroup>
              <Field
                title='Mail To'
                className='form-control'
                type='text'
                name='mailTo'
                onInput={() => {}}
                placeholder='test@energyimpact.com'
                required={true}
                defaultValue={mail.sender.emailAddress.address}
                readOnly={true}
              />
            </FormGroup>
            <FormGroup>
              <Textarea
                title='Mail Body'
                className='form-control'
                type='textarea'
                name='message'
                onInput={handleMailBodyInputChange}
                placeholder='Mail body'
                required={true}
              />
            </FormGroup>
          </FormGroup>
        </Modal.Body>
        <Modal.Footer className='justify-content-end'>
          <button type='submit' className='btn btn-primary btn-sm'>
            Reply Mail
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  )
}

export default ReplyMailModal
